module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-06-6bcac63dec0eb0da44fe5f6d861bf3c2.jpg";